<template>
  <collapse title="Épreuves" :defaultCollapse="false">
    <sport @change="$emit('changeSport', $event)"/>
    <discipline @change="$emit('changeDiscipline', $event)"/>
    <event @change="$emit('changeEvent', $event)" />
    <classification @change="$emit('changeClassification', $event)" />
    <gender @change="$emit('changeGender', $event)" />
    <event-units @change="$emit('changeEventUnits', $event)" />
  </collapse>
</template>

<script>
import Collapse from '@/components/tools/collapse/Collapse'

import Classification from '@/components/sport/games/filters/event/Classification'
import Discipline from '@/components/sport/games/filters/event/Discipline'
import Event from '@/components/sport/games/filters/event/Event'
import EventUnits from '@/components/sport/games/filters/event/EventUnits'
import Gender from '@/components/sport/games/filters/event/Gender'
import Sport from '@/components/sport/games/filters/event/Sport'
export default {
  name: 'SportGamesFiltersEvent',
  components: { Classification, Collapse, Discipline, Event, EventUnits, Gender, Sport }
}
</script>
